import React, { useState, useEffect } from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import "./Sidebar.css";
import {
  HouseDoorFill,
  GearWideConnected,
  BellFill,
  Power,
  Gear,
  FileEarmarkText,
  Link,
} from "react-bootstrap-icons";
import { useMsal } from "@azure/msal-react";

const Sidebar: React.FC = () => {
  const { instance } = useMsal();

  const location = useLocation();
  const [expandSettings, setExpandSettings] = useState<boolean>(false);

  useEffect(() => {
    if (!location.pathname.startsWith("/settings")) {
      setExpandSettings((es) => false);
    }
  }, [location]);

  const onClickSettings = () => {
    setExpandSettings((es) => !es);
  };

  const handleLogout = () => {
    localStorage.clear();
    instance
      .logoutRedirect({
        postLogoutRedirectUri: "/", // Redirect to home after logout
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
  };

  return (
    <div style={{ display: "flex" }}>
      <title>Pinergy - Load Profile</title>
      <div className="sidebar-container">
        <div className="sidebar-logo">
          <a href="/">
            <img
              src="/Pinergy_logo.png"
              alt="Pinergy Logo"
              style={{ cursor: "pointer" }}
            />
          </a>
        </div>
        <div className="sidebar-menu-container">
          <NavLink
            end
            className={({ isActive }) =>
              `sidebar-menu-item ${isActive ? "sidebar-menu-item-active" : ""}`
            }
            to="/"
          >
            <HouseDoorFill />
            Dashboard
          </NavLink>
          <NavLink
            end
            className={({ isActive }) =>
              `sidebar-menu-item ${isActive ? "sidebar-menu-item-active" : ""}`
            }
            to="/integrations"
          >
            <Link />
            Integrations
          </NavLink>
          <NavLink
            end
            className={({ isActive }) =>
              `sidebar-menu-item ${isActive ? "sidebar-menu-item-active" : ""}`
            }
            to="/logs"
          >
            <FileEarmarkText />
            Logs
          </NavLink>
          <NavLink
            end
            className={({ isActive }) =>
              `sidebar-menu-item ${isActive ? "sidebar-menu-item-active" : ""}`
            }
            to="/alerts"
          >
            <BellFill />
            Alerts
          </NavLink>
          <div>
            <div
              onClick={onClickSettings}
              className={`sidebar-menu-item ${
                location.pathname.startsWith("/settings")
                  ? "sidebar-menu-item"
                  : ""
              } ${expandSettings ? "sidebar-menu-item-expanded" : ""}`}
            >
              <GearWideConnected />
              Settings
            </div>
            <div
              className={
                expandSettings ? "sidebar-submenu" : "sidebar-submenu-hidden"
              }
            >
              <NavLink
                className={({ isActive }) =>
                  `sidebar-submenu-item ${
                    isActive ? "sidebar-menu-item-active" : ""
                  }`
                }
                to="/settings/loadprofile"
              >
                Load Profile
              </NavLink>
            </div>
            <div
              className={
                expandSettings ? "sidebar-submenu" : "sidebar-submenu-hidden"
              }
            >
              <NavLink
                className={({ isActive }) =>
                  `sidebar-submenu-item ${
                    isActive ? "sidebar-menu-item-active" : ""
                  }`
                }
                to="/settings/alertemails"
              >
                Email Alerts
              </NavLink>
            </div>
            <div
              className={
                expandSettings ? "sidebar-submenu" : "sidebar-submenu-hidden"
              }
            >
              <NavLink
                className={({ isActive }) =>
                  `sidebar-submenu-item ${
                    isActive ? "sidebar-menu-item-active" : ""
                  }`
                }
                to="/settings/logmanagement"
              >
                Log Management
              </NavLink>
            </div>
          </div>
          <div className="filler"></div>
        </div>
        <div className="sidebar-menu-item" onClick={handleLogout}>
          <Power />
          <p>Sign out</p>
        </div>
      </div>
      <div className="content-container">
        <Outlet />
      </div>
    </div>
  );
};

export default Sidebar;
